"use client";

import { FC } from "react";
import CountUp from "react-countup";
import { IClientCountUpProps } from "./types";

const ClientCountUp: FC<IClientCountUpProps> = ({ countStart, countStop, duration }) => (
  <div>
    <CountUp start={countStart} end={countStop} duration={duration} />%
  </div>
);

export default ClientCountUp;
